import React from "react";
import Avatar from 'react-avatar';

interface Props {
    name?: string;
    size?: number;
    src?: string;
}

const AppAvatar = (props: Props) => {
    const { name, size, src } = props;
    return <Avatar textSizeRatio={3} src={src} round={true} size={size ? size.toString() : "36"} name={name} />
}

export default AppAvatar;